import i18n from '@rmdy/rmdy-translations-frontend';
import groupService from './group.service';

const group = {
	namespaced: true,
	state: {
		groups: [],
		isSearchingGroups: false,
		setIsSavingGroup: false,
	},
	actions: {
		async getAllGroups({ commit, dispatch }) {
			commit('setIsSearchingGroups', true);
			try {
				const result = await groupService.getAllGroups();
				commit('setGroups', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingGroups', false);
		},
		async getGroupsById({ commit, dispatch }, id) {
			commit('setIsSearchingGroups', true);
			try {
				const result = await groupService.getGroupById(id);
				commit('setGroupDetails', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingGroups', false);
		},
		async createGroup({ dispatch, commit }, groupDetail) {
			commit('setIsSavingGroup', true);
			try {
				await groupService.createGroup(groupDetail);
				dispatch('getAllGroups');
				dispatch('toast/makeToast', { message: 'admin.item-saved' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingGroup', false);
		},
		async updateGroup({ dispatch, commit }, groupDetail) {
			commit('setIsSavingGroup', true);
			try {
				await groupService.updateGroup(groupDetail);
				dispatch('getAllGroups');
				dispatch('toast/makeToast', { message: 'admin.item-updated' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingGroup', false);
		},
		async deleteGroup({ state, dispatch, commit }, groupId) {
			try {
				const groupToDelete = state.groups.find(oldGroup => oldGroup._id === groupId);
				if (groupToDelete && groupToDelete.count === 0) {
					await groupService.deleteGroup(groupId);
					commit('setGroups', Array.of(...state.groups.filter(oldGroup => oldGroup._id !== groupId)));
					dispatch('toast/makeToast', { message: 'admin.item-removed' }, { root: true });
				} else {
					dispatch('toast/makeToast', {
						message: i18n.i18n.t('groups.store.error.group-user-count'),
						type: 'error'
					}, { root: true });
				}
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data.message,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		},
	},
	mutations: {
		setGroups(state, groups) {
			state.groups = groups;
		},
		setIsSearchingGroups(state, searchState) {
			state.isSearchingGroups = searchState;
		},
		setIsSavingGroup(state, saveState) {
			state.isSavingGroup = saveState;
		},
	},
};

export default group;
